import React from 'react';
import FundingAIRecommendationCard from './FundingAIRecommendationCard';

const FundingAIRecommendationList = ({
  recommendations,
  loading,
  savingId,
  onAccept,
  onDismiss,
  onComplete,
  emptyLabel = 'No open recommendations yet.',
}) => {
  if (loading) return <p className="text-sm text-[var(--fg-muted)]">Loading recommendations...</p>;
  if (!recommendations?.length) return <p className="text-sm text-[var(--fg-muted)]">{emptyLabel}</p>;

  return (
    <div className="space-y-3">
      {recommendations.map((recommendation) => (
        <FundingAIRecommendationCard
          key={recommendation.id}
          recommendation={recommendation}
          saving={savingId === recommendation.id}
          onAccept={onAccept}
          onDismiss={onDismiss}
          onComplete={onComplete}
        />
      ))}
    </div>
  );
};

export default FundingAIRecommendationList;
